<template>
  <div>
    <v-row v-for="(group, i) in data.logoGroups" :key="i" class="pb-12" align="center" justify="center">
      <v-col v-if="group.title" cols="12"><h3>{{group.title}}</h3></v-col>
      <v-col cols="12" class="align-center">
        <template v-for="(logo, k) in group.logos" >
          <a :key="k" class="logo" :href="logo.link" rel="noopener" target="_blank" :aria-label="`Sponsor ${k}`" v-if="logo.link">
            <seo-v-img :src="optimizedImageURL(logo.image, {width: 300})" :aspect-ratio="getAspectRatio(logo.image)" contain eager max-width="150" :width="50*getAspectRatio(logo.image)"/>
          </a>
          <div :key="k" class="logo" v-else>
            <seo-v-img :src="optimizedImageURL(logo.image, {width: 300})" :aspect-ratio="getAspectRatio(logo.image)" contain eager max-width="150" :width="50*getAspectRatio(logo.image)"/>
          </div>
        </template>
      </v-col>
    </v-row>
  </div>
  <!-- <transition appear name="from-below">
  </transition> -->
</template>

<script>
import { optimizedImageURL, getAspectRatio } from '@/services/OptimizedImage'

export default {
  name: 'ContentLogoRow',
  props: {
    data: {
      type: Object,
      required: true
    },
    full: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    optimizedImageURL,
    getAspectRatio,
    groupCols (i) {
      let totalLogos = 0
      let groupLogos = 0
      this.data.logoGroups.forEach((g, gi) => {
        g.logos.forEach(l => {
          totalLogos++
          if (gi === i) groupLogos++
        })
      })

      return Math.round(12 / (totalLogos / groupLogos))
    }
  }
}
</script>

<style lang="scss" scoped>
// .logo-group {
//   position: relative;

//   &::before {
//     content: '';
//     position: absolute;
//     left: 0;
//     bottom: 0;
//     height: 75%;
//     width: 1px;
//     @include breakpoint('lg-and-up') {
//       background-color: map-get($shades, 'black');
//     }
//   }

//   &:nth-child(1) {
//     &::before {
//       background-color: transparent;
//     }
//   }
// }
.logo {
  display: inline-flex;
  height: 50px;
  margin: 0 15px 15px;
  vertical-align: middle;
  align-items: center;
}

h3 {
  width: 100%;
}
</style>
